export enum WineTypeEnum {
  RED = "red",
  WHITE = "white",
  SPARKLING = "sparkling",
  ROSE = "rose",
  DESSERT = "dessert",
  FORTIFIED = "fortified",
  UNKNOWN = "unknown",
}
